import * as $ from 'jquery';
import { SubmittableFilter } from 'Components/Filters/SubmittableFilter';
import { onChange, onLoad } from 'Core/Events';

/**
 * @module Sort
 * @description Komponent sortujący produkty na stronie produktów. Nie mylić z filtrami, które mają zupełnie oddzielną logikę
 * Komponent ten wykorzystuje plugin JquerySelectric do wyświetlania customowych selectów. 
 * Zasada działania tego komponentu polega na tym, ze po wybraniu odpowiedniej opcji z selecta, submituje sie formularz
 * w ktorym Sort od strony templatek jest zamkniety 
 */

export const Sort = (() => {

    const Selector =  {
        SELECT_SORT_BY: "#srt_2",
        SELECT_ON_PAGE: "#srt_1",
        FORM:           "#filter-form",
    };

    onLoad(initCustomSelects);
    onChange(Selector.SELECT_ON_PAGE, applySortingValuesAfterSelect);
    onChange(Selector.SELECT_SORT_BY, applySortingValuesAfterSelect);

    function initCustomSelects() {
        initSortSelects();
    }

    function initSortSelects() {
        /** @link https://selectric.js.org/ */
        let options = {
            arrowButtonMarkup: /* html */`<b class="button mr-3"><i class="fa fa-chevron-down d-block"></i></b>`,
            nativeOnMobile: false,
            inheritOriginalWidth: false,
            expandToItemText: true,
            allowWrap: false,
            onChange: function(element) {
              $(element).change();
            },
        }

        $(Selector.SELECT_SORT_BY).selectric(options);
        $(Selector.SELECT_ON_PAGE).selectric(options);
    }
    
    async function applySortingValuesAfterSelect() {
        $(this).addClass(SubmittableFilter.readyToBeSubmittedClass).trigger('selectricChangeFilters', this);
    }
})();
import * as $ from 'jquery';
import { SubmittableFilter } from 'Components/Filters/SubmittableFilter';
import { onChange, onLoad } from 'Core/Events';

/**
 * @module Sort
 * @description Komponent sortujący produkty na stronie produktów. Nie mylić z filtrami, które mają zupełnie oddzielną logikę
 * Komponent ten wykorzystuje plugin JquerySelectric do wyświetlania customowych selectów. 
 * Zasada działania tego komponentu polega na tym, ze po wybraniu odpowiedniej opcji z selecta, submituje sie formularz
 * w ktorym Sort od strony templatek jest zamkniety 
 */

export const Sort = (() => {

    const Selector =  {
        SELECT_SORT_BY: "#srt_2",
        SELECT_ON_PAGE: "#srt_1",
        FORM:           "#filter-form",
    };

    onLoad(initCustomSelects);
    onChange(Selector.SELECT_ON_PAGE, applySortingValuesAfterSelect);
    onChange(Selector.SELECT_SORT_BY, applySortingValuesAfterSelect);

    function initCustomSelects() {
        initSortSelects();
    }

    function initSortSelects() {
        /** @link https://selectric.js.org/ */
        let options = {
            arrowButtonMarkup: /* html */`<b class="button mr-3"><i class="fa fa-chevron-down d-block"></i></b>`,
            nativeOnMobile: false,
            inheritOriginalWidth: false,
            expandToItemText: true,
            allowWrap: false,
            onChange: function(element) {
              $(element).change();
            },
        }

        $(Selector.SELECT_SORT_BY).selectric(options);
        $(Selector.SELECT_ON_PAGE).selectric(options);
    }
    
    async function applySortingValuesAfterSelect() {
        $(this).addClass(SubmittableFilter.readyToBeSubmittedClass).trigger('selectricChangeFilters', this);
    }
})();
